module.exports = fox._r("images/clean-thumb-tall.gif", __webpack_public_path__ + "images/clean-thumb-tall.gif");


//////////////////
// WEBPACK FOOTER
// ./images/clean-thumb-tall.gif
// module id = 1032
// module chunks = 4